export default __webpack_public_path__ + "static/media/phone.9b835986.png";